import { getDaysInMonth } from 'date-fns';
import { useCallback } from 'react';
import type { BirthDateType } from '../BirthDatePicker';

export const useBirthDateChange = (
  value?: Partial<BirthDateType>,
  onChange?: (value: Partial<BirthDateType>) => void,
) =>
  useCallback(
    (date: Partial<BirthDateType>) => {
      const { day, month, year } = { ...value, ...date };

      const daysInMonth = year !== undefined && month !== undefined ? getDaysInMonth(new Date(year, month)) : undefined;

      const isNumberOfDaysValid = daysInMonth !== undefined && day !== undefined && daysInMonth >= day;

      return onChange?.({
        date:
          day !== undefined && month !== undefined && year !== undefined && isNumberOfDaysValid
            ? new Date(year, month, day, 12, 0)
            : undefined,
        day,
        isNumberOfDaysValid,
        month,
        year,
      });
    },
    [value, onChange],
  );
